(function () {
  const updatePaginationState = (section, activeIndex) => {
    section.querySelectorAll("[data-featured-collection-pagination]").forEach((pagination) => {
      pagination.querySelectorAll("[data-featured-collection-bullet]").forEach((bullet, bulletIndex) => {
        const isActive = bulletIndex === activeIndex;
        bullet.classList.toggle("is-active", isActive);
        bullet.setAttribute("aria-current", isActive ? "true" : "false");
      });
    });
  };

  const renderPagination = (section, slideCount, swiper) => {
    section.querySelectorAll("[data-featured-collection-pagination]").forEach((pagination) => {
      pagination.innerHTML = "";

      if (slideCount <= 1) {
        pagination.style.display = "none";
        return;
      }

      pagination.style.display = "";

      for (let index = 0; index < slideCount; index += 1) {
        const bullet = document.createElement("button");
        bullet.type = "button";
        bullet.className = "featured-collection-slider__bullet";
        bullet.setAttribute("data-featured-collection-bullet", "");
        bullet.setAttribute("aria-label", `Go to slide ${index + 1}`);
        bullet.addEventListener("click", () => swiper.slideTo(index));
        pagination.appendChild(bullet);
      }
    });

    updatePaginationState(section, swiper.activeIndex || 0);
  };

  const initSectionSlider = (section) => {
    const slider = section.querySelector("[data-featured-collection-slider]");

    if (!slider || slider.swiper || typeof Swiper === "undefined") {
      return;
    }

    const slideCount = slider.querySelectorAll(".swiper-slide").length;

    const swiper = new Swiper(slider, {
      slidesPerView: 1,
      speed: 700,
      effect: "fade",
      watchOverflow: true,
      autoHeight: true,
      on: {
        init(swiperInstance) {
          renderPagination(section, slideCount, swiperInstance);
        },
        slideChange(swiperInstance) {
          updatePaginationState(section, swiperInstance.activeIndex);
        }
      }
    });

    renderPagination(section, slideCount, swiper);
  };

  const buildVariantUrl = (url, variantId) => {
    if (!url || !variantId) return url;
    const separator = url.includes("?") ? "&" : "?";
    const cleanUrl = url.replace(/([?&])variant=\d+/g, "").replace(/[?&]$/, "");
    const finalSeparator = cleanUrl.includes("?") ? "&" : "?";
    return `${cleanUrl}${finalSeparator}variant=${variantId}`;
  };

  const updateCardLinksForVariant = (swatchInput) => {
    const card = swatchInput.closest(".featured-collection__product-slide");
    if (!card) return;

    const variantId = swatchInput.dataset.variantId;
    if (!variantId) return;
    const isAvailable = swatchInput.dataset.optionAvailable === "true";

    const selectors = [
      ".featured-collection__product-image-link",
      ".Product_title a"
    ];

    selectors.forEach((selector) => {
      card.querySelectorAll(selector).forEach((link) => {
        const currentHref = link.getAttribute("href");
        if (!currentHref) return;
        link.setAttribute("href", buildVariantUrl(currentHref, variantId));
      });
    });

    card.querySelectorAll("[data-featured-collection-variant-input]").forEach((input) => {
      input.value = variantId;
      input.disabled = !isAvailable;
    });

    card.querySelectorAll("[data-testid='featured-collection-add-to-cart']").forEach((button) => {
      button.disabled = !isAvailable;
    });
  };

  const initVariantSwatchLinks = () => {
    document.querySelectorAll(".featured-collection__swatch-list input[type='radio'][data-variant-id]").forEach((input) => {
      if (input.dataset.featuredSwatchBound === "true") return;
      input.dataset.featuredSwatchBound = "true";

      input.addEventListener("change", () => {
        if (!input.checked) return;
        updateCardLinksForVariant(input);
      });
    });
  };

  const initSection = (section) => {
    if (!section || section.dataset.featuredCollectionInitialized === "true") return;

    initSectionSlider(section);
    initVariantSwatchLinks();
    section.dataset.featuredCollectionInitialized = "true";
  };

  const initAllFeaturedCollectionSliders = () => {
    const sections = document.querySelectorAll(".featured-collection-slider");

    if (!("IntersectionObserver" in window)) {
      sections.forEach(initSection);
      return;
    }

    const observer = new IntersectionObserver(
      (entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          initSection(entry.target);
          currentObserver.unobserve(entry.target);
        });
      },
      {
        rootMargin: "300px 0px",
        threshold: 0.01
      }
    );

    sections.forEach((section) => {
      if (section.dataset.featuredCollectionObserved === "true") return;
      section.dataset.featuredCollectionObserved = "true";
      observer.observe(section);
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAllFeaturedCollectionSliders);
  } else {
    initAllFeaturedCollectionSliders();
  }

  window.addEventListener("load", initAllFeaturedCollectionSliders);
  document.addEventListener("shopify:section:load", initAllFeaturedCollectionSliders);
})();
